import React, { useEffect, useState } from "react";
import { setIvrExtension } from "context";
import { application } from "globals/endpoints";
import { useMaterialUIController } from "context";
import Hotel from "application/modules/configuration/hotel";
import IVR from "application/modules/configuration/ivr";
import CallCenterConfigurations from "application/modules/configuration/callCenterConfiguration";
import PhoneVOIP from "application/modules/extensionConfiguration/phone+VOIP";
import PhoneVOLTE from "application/modules/extensionConfiguration/phone+VOLTE";
import ExtensionFax from "application/modules/extensionConfiguration/fax";
import ENM from "application/modules/extensionConfiguration/enm";
import NGX from "application/modules/extensionConfiguration/ngx";
import SoftFax from "application/modules/extensionConfiguration/softFax";
import RemoteuserSIP from "application/modules/extensionConfiguration/remoteuserSIP";
import CMS from "application/modules/extensionConfiguration/cms";
import CMSOther from "application/modules/extensionConfiguration/cmsOther";
import CBN from "application/modules/extensionConfiguration/cbn";
import CBNOther from "application/modules/extensionConfiguration/cbnOther";
import EmergencyPhone from "application/modules/extensionConfiguration/emergencyPhone";
import DialPlan from "application/modules/extensionConfiguration/dialPlan";
import Dispatcher from "application/modules/extensionConfiguration/Dispatcher";
import VoicePromptFeature from "application/modules/extensionConfiguration/VoicePromptFeature";
import PhoneVONR from "application/modules/extensionConfiguration/phoneVONR";
import PhoneMCXVideo from "application/modules/extensionConfiguration/phoneMCXVideo";

const GetComponent = ({
  currentFolder,
  onLoad = () => {},
  parentFolderType,
  pageId,
  searchText,
  registerCallBacks,
  pageName,
}) => {
  const [acdList, setAcdList] = useState([]);
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  const getExtension = async () => {
    try {
      const response = await application.post("/queue/list/acdList");
      if (response.data.status === "OK") {
        setAcdList(response.data.data);
      } else {
        console.error("Failed to fetch ACD list:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching ACD list:", error);
    }
  };

  useEffect(() => {
    getExtension();
  }, [currentFolder]);
  useEffect(() => {
    const matchingAcd =
      acdList &&
      acdList.find((data) => {
        return data?.acdNumber === currentFolder?.name;
      });
    const updatedName = matchingAcd ? matchingAcd :  currentFolder && currentFolder?.name;
    setIvrExtension(dispatch, {
      code: updatedName,
      changedOn: Date.now(),
    });
  }, [currentFolder]);
  return (
    <>
      {parentFolderType === "IVR" ? (
        <IVR
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
        />
      ) : parentFolderType === "CallCenter" ? (
        <CallCenterConfigurations
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
        />
      ) : parentFolderType === "extension" ? (
        <Hotel
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
        />
      ) : parentFolderType === "phone" ? (
        <PhoneVOIP
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "volte" ? (
        <PhoneVOLTE
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "vonr" ? (
        <PhoneVONR
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "mcxvideo" ? (
        <PhoneMCXVideo
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "fax" ? (
        <ExtensionFax
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "softfax" ? (
        <SoftFax
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "enm" ? (
        <ENM
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "ngx" ? (
        <NGX
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "remoteuser" ? (
        <RemoteuserSIP
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "cms" ? (
        <CMS
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "cmsother" ? (
        <CMSOther
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "cbn" ? (
        <CBN
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "cbnother" ? (
        <CBNOther
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "emergencyphone" ? (
        <EmergencyPhone
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "dialplan" ? (
        <DialPlan
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "dispatcher" ? (
        <Dispatcher
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : parentFolderType === "ivr" ? (
        <VoicePromptFeature
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      ) : (
        <Hotel
          onLoad={onLoad}
          registerCallBacks={registerCallBacks}
          pageId={pageId}
          searchText={searchText}
          pageName={pageName}
          isFolderexist={true}
        />
      )}
      {/* {parentFolderType === "IVR" ? (
    <>IVR</>
  ) : parentFolderType === "CallCenter" ? (
    <>Call Center</>
  ) : parentFolderType === "extension" ? (
    <>Extension</>
  ) : parentFolderType === "phone" ? (
    <>Phone</>
  ) : (
    <>Nothing has selected :</>
  )} */}
    </>
  );
};

export default GetComponent;
